import { authClient } from '@/customer/lib/auth'

/**
 * Overlay shown to members whose session was minted by staff
 * impersonation. Renders nothing for regular sessions, so it's safe
 * to mount unconditionally in production. Surfaces the acting
 * `staff.id` and a button to end the impersonated session.
 */
export function ImpersonationBanner() {
  const { data } = authClient.useSession()

  if (!data?.session.impersonatedBy) return null

  const impersonatedBy = data.session.impersonatedBy

  return (
    <div className="fixed top-2 right-2 z-50 rounded-md border border-border/60 bg-background/90 px-2.5 py-1.5 font-mono text-[11px] leading-tight text-foreground shadow-sm backdrop-blur">
      <div className="pointer-events-none flex items-center gap-2">
        <span className="inline-block h-2 w-2 rounded-full bg-fuchsia-500" />
        <span className="font-semibold">auth: impersonating</span>
      </div>
      <div className="pointer-events-none mt-1 space-y-0.5 text-muted-foreground">
        <div>user: {data.user.email}</div>
        <div>by: {impersonatedBy.slice(0, 12)}…</div>
      </div>
      <button
        type="button"
        onClick={() => void authClient.signOut()}
        className="mt-1.5 cursor-pointer text-foreground underline underline-offset-2 hover:no-underline"
      >
        stop impersonating
      </button>
    </div>
  )
}
